import type { IMessageBase } from './base';

export const MESSAGE_TYPE = 'KEEP_ALIVE';

export interface IMessageKeepAlive extends IMessageBase {
    type: 'KEEP_ALIVE';
    payload: {};
}
